<template>
  <section class="content">
    <admin-header
      :title="'Financial Codes'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminFinancialCode',
    data () {
      return {
        newEntityScreen: 'Admin - Financial Codes',
        searchEntityScreen: 'Admin - Financial Code search',
        filterEventName: 'admin-financial-code-filter',
        filterName: 'FinancialCodeFilter',
        entityName: 'financial-code'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/FinancialCode/AdminFinancialCode.vue